module.exports = __webpack_public_path__ + "eb66ff17a2c201193df750c97a304e40.svg";